
import { TaskTypeModelType } from '@teinor/erp/types/company/task/taskType'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderBoolean, CustomRenderColor, CustomRenderDisplayHoursByMins, CustomRenderIcon, DeleteRow, EditRowNotLink } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalCETaskType from './ModalCETaskType'
import { dictIcon } from '../../../../../../utils/icons'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import useProductActiveDictionary from '../../../../../../utils/hooks/product/useProductActiveDictionary'
import ModalChangeActiveTaskType from './ModalChangeActiveTaskType'
import { faRotateLeft } from '@fortawesome/pro-light-svg-icons'

interface TaskTypesProps extends ComponentWithPermissions { }

const TaskTypes: React.FC<TaskTypesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('taskTypes', 'Tipos de tarea'),
        newText: t('newTaskType', 'Nuevo tipo de tarea'),
    }

    return (
        <BaseScreenTable TableComponent={TableTaskTypes} CreateModalComponent={ModalCETaskType} EditModalComponent={ModalCETaskType} DeleteModalComponent={ModalChangeActiveTaskType} pageData={pageData} userPermissions={userPermissions} />
    )
}

type TableTaskTypesProps = TableComponentProps & {}

const TableTaskTypes: React.FC<TableTaskTypesProps> = ({ setTableInstance, setOpened, userPermissions }) => {
    const { t } = useTwinTranslation()
    const { productActiveDict } = useProductActiveDictionary()
    const columns: ColumnTableSchema<TaskTypeModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'color',
            dataKey: 'color',
            label: t('color', 'Color'),
            customRender: (parameterValue) => <CustomRenderColor value={parameterValue} />
        },
        {
            id: 'icon',
            dataKey: 'icon',
            label: t('icon', 'Icono'),
            customRender: (parameterValue) => <CustomRenderIcon icon={dictIcon[parameterValue]} />
        },
        {
            id: 'defaultMins',
            dataKey: 'defaultMins',
            label: t('estimatedTime', 'Tiempo estimado'),
            customRender: (parameterValue) => <CustomRenderDisplayHoursByMins value={parameterValue}/>
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            hideColumnByDefault: true,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: { items: productActiveDict, label: t('active', 'Activo') }
            },
            generalSearchable: false
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} icon={!allRowData?.active ? faRotateLeft : undefined} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable name='TaskTypes' columns={columns} getDataFrom='/api/app/task/taskType/getAllTaskTypes' onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} setTableInstance={setTableInstance} />
    )
}

export default TaskTypes
